module.exports = __webpack_public_path__ + "media/src/assets/images/bg-new-99b75fed9513b622779d2a8c448d233f.svg";